import React, {Component, createRef} from 'react'
import {withTranslation} from 'react-i18next'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'

import UserMenu from './UserMenu'
import SubHeader from './SubHeader'
import Navigation from '../navigation'
import Notifications from './Notifications'
import Message from'./Message'
import {Col} from '@amzn/stencil-react-components/layout'
import {H1} from "@amzn/stencil-react-components/text";

class Header extends Component {
  constructor(props) {
    super(props);
    this.title = createRef();
  }

  render() {
    const {messages, t} = this.props;

    return (
      <Col gridGap="S400">
        <UserMenu/>
        {messages.map((message) => {
          if (!message.data?.dismissed) {
            return <Message message={message} defaultFocus={this.title}/>
          }
          })
        }
        <H1 tabIndex="-1" ref={this.title}>{t('Header.Title')}</H1>
        <SubHeader/>
        <Notifications/>
        <Navigation/>
      </Col>
    )
  }
}

const mapState = state => ({
  messages: state.flashMessage.messages
});

export default withRouter(connect(mapState)(withTranslation('translationsV2')(Header)))
